export function addUrlPrefix(url: string) {
  if (url.startsWith("https://") || url.startsWith("http://")) {
    return url;
  } else {
    return "http://".concat(url);
  }
}
